(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sd-wrappers"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click', function(e){
    var pkg = e.target.closest('.package');
    if (!pkg) return;
    pkg.classList.toggle('opened');
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var pkg = document.activeElement && document.activeElement.closest && document.activeElement.closest('.package');
    if (!pkg) return;
    e.preventDefault();
    pkg.classList.toggle('opened');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
